var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M479 43L479 45L1 45L1 43L479 43Z",
  fill: "#E6E6E6"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 44,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 44,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 303,
  cy: 44,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 444,
  cy: 44,
  r: 7,
  fill: "white",
  stroke: "#E6E6E6",
  strokeWidth: 2
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 31,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref8 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 10,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 41,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 51,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref11 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 61,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref12 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 71,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref13 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 81,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref14 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 91,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref15 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 101,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 111,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref17 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 121,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 131,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref19 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 141,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref20 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 151,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref21 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 172,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 182,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref23 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 192,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref24 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 202,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 212,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref26 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 222,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref27 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 232,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref28 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 242,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref29 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 252,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref30 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 262,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref31 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 272,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 282,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref33 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 292,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref34 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 454,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref35 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 313,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref36 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 323,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref37 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 333,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 343,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref39 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 353,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 363,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 373,
  y: 16,
  width: 1,
  height: 24,
  fill: "#666666"
});
var _ref42 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 383,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref43 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 393,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref44 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 403,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref45 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 413,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref46 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 423,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref47 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 433,
  y: 24,
  width: 1,
  height: 16,
  fill: "#808080"
});
var _ref48 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_335_55341)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_di_335_55341)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M414 22C415.778 22 422 14.7005 422 10.1818C422 5.66312 418.418 2 414 2C409.582 2 406 5.66312 406 10.1818C406 14.7005 412.222 22 414 22ZM414 14C416.209 14 418 12.2091 418 10C418 7.79086 416.209 6 414 6C411.791 6 410 7.79086 410 10C410 12.2091 411.791 14 414 14Z",
  fill: "#808080"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_di_335_55341)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 414,
  cy: 10,
  r: 3,
  fill: "#666666"
})));
var _ref49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_di_335_55341",
  x: 404,
  y: 1,
  width: 20,
  height: 24,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_335_55341"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_335_55341",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_335_55341"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_di_335_55341",
  x: 409,
  y: 6,
  width: 10,
  height: 10,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_335_55341"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_335_55341",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_335_55341"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_335_55341"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(402)"
})));
function SvgOverallReviewIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 52,
    viewBox: "0 0 464 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallReviewIllustration);
export default __webpack_public_path__ + "static/media/overall-review-illustration.fcb07611eb4de023e9130019c01a3d54.svg";
export { ForwardRef as ReactComponent };